import { render } from "./footer-en.vue?vue&type=template&id=0216fe1a&scoped=true"
import script from "./footer-en.vue?vue&type=script&lang=js"
export * from "./footer-en.vue?vue&type=script&lang=js"

import "./footer-en.vue?vue&type=style&index=0&id=0216fe1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0216fe1a"]])

export default __exports__